import { Card, IdCardDto } from '../../types';

export const mapCards = (idCards: IdCardDto[]): Card[] =>
  idCards.map((idCard) => ({
    id: idCard.id,
    userId: idCard.user_id,
    name: idCard.name,
    iconCode: idCard.icon_code,
    displayOrder: idCard.display_order,
    createdAt: idCard.created_at,
    updatedAt: idCard.updated_at,
    frontImage: idCard.front_image,
    backImage: idCard.back_image,
  }));
